import {
  ActionType,
  IUpdateUserStatusPayload,
  UpdateUserStatusResponse,
} from "models/userListBusiness/updateUserStatus";

export const updateUserStatusAction = (payload: IUpdateUserStatusPayload) => {
  return {
    type: ActionType.UPDATE_USER_STATUS,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.UPDATE_USER_STATUS_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: UpdateUserStatusResponse) => {
  return {
    type: ActionType.UPDATE_USER_STATUS_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.UPDATE_USER_STATUS_RESET,
  };
};
